<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout"
                               active
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="support()">
                               Support
    </b-nav-item>
    </b-nav>
    </div>
    <div>
    <div class="main-div">
    <div class="login-div">
    <div class="profile-div col-11">
      <h5 class="mt-3 mb-3"> FAQ </h5><br>
      <p>

          <h6><b>Q. Is the software available to download and test?</b></h6>
          The software is available free of charge for 30 days trail period at <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a> <br><br><br>

          <h6><b>Q. Is there any reporting capabilities?</b></h6>
          Facit offer a separate Reporting Suite that can be connected to the people counting application.<br>
          The reporting suite can be accessed from our portal at <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a>
          <br><br><br>

          <h6><b>Q. Can the report provide the timestamp information for every counter?</b></h6>
          Facit application only stores meta data i.e. the timestamp information and number of people. The raw data includes these two pieces of information which is accessible from the software. <br><br><br>

          <h6><b>Q. How many objects can be tracked in a scene?  Could the software also count the tracked item in a view and return area count?</b></h6>
          The software tracked all the objects in the scene and return the total number of objects in the scene. Currently it only returns the number of objects crossing the counting zone. <br><br><br>

          <h6><b>Q. Is there a multilanguage version of the software?</b></h6>
          The software is currently available in English. <br><br><br>

          <h6><b>Q. What is the accuracy of the counting system?</b></h6>
          The accuracy of the system depends on the field of view and camera position. Our internal testing showed over 95% accuracy. <br><br><br>

          <h6><b>Q. What is the required camera resolution and frame rate?</b></h6>
          The software works on 320x240 resolution at min 5 frames per second.<br><br><br>

          <h6><b>Q. How many cameras can be the software handled?</b></h6>
          There is no limit to the number of cameras the software can handle, this depends on the hardware. The recommended hardware for up to 4
          channel and up to 8 channel systems are listed in the product sheet which can be found at
          <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a><br><br><br>

          <h6><b>Q. The application only work with IP camera or the traditional coax cable camera?</b></h6>
          The application takes IP video feed. Any analogue cameras will need to be first converted to digital using standard converters. <br><br><br>

          <h6><b>Q. Is it possible to count people with wheelchairs / bicycles?</b></h6>
          Currently the software is only available to count people. <br><br><br>

          <h6><b>Q. Can it work with 360 fisheye fixed cameras?</b></h6>
          The software is only tested for fixed dome cameras. It is available for free 30 days trail at
          <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a><br><br><br>

          <h6><b>Q. Is there an API to enable the data to be obtained by third party systems?</b></h6>
          Yes, the counting data is available on the network.<br><br><br>

          <h6><b>Q. If the doors are opening and closing through the scene will it effect the count?</b></h6>
          No, the opening and closing of the doors will not effect the counting. <br><br><br>

          <h6><b>Q. Can you expand on your hardware and licencing model?</b></h6>
          Recommended hardware for up to 4 channel and 8 channel system is available on the product sheet available at
          <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a>.
          The software is offered as one off capital purchase with yearly SLA <br><br><br>

          <h6><b>Q. What are the hardware requirements? Any particular GPU models?</b></h6>
          Recommended hardware for up to 4 channel and 8 channel system is available on the product sheet available at
          <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a><br><br><br>

          <h6><b>Q. Can we link multiple 8 channel systems into one virtual system OR do we need to use one server for all cameras?</b></h6>
          Multiple instances of the software can be linked together through our reporting suite. <br><br><br>

          <h6><b>Q. Can camera view (top view) or (prospect view) impact on accuracy? If yes what is the suggested view?</b></h6>
          The suggested camera views are available in the camera mounting guide available at
          <a href="https://portal.facitdatasystems.com/#/peoplecounting">https://portal.facitdatasystems.com/#/peoplecounting</a><br><br><br>

          <h6><b>Q. Would it be possible to trigger a local output according to a specific threshold (addressable IP module) to open or closing doors?</b></h6>
          Facit Notification App can be used to trigger the stop/go or door open and close signal using the I/O module. This has been used by number of
          different systems to monitor occupancy of a given environment.<br><br><br>

          <h6><b>Q. Can this application run as the windows system service (means no user login required and no UI app running)?</b></h6>
          The application runs as a service. The GUI is just to configure the application. The GUI can be closed once the setup is completed. <br><br><br>
    </p>
    </div>
</div>
</div>
</div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';

export default {
  name: 'faq',
  components: { FacitHeader },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    faq() {
      this.$router.push('faq');
    },
    dashboard() {
      this.$router.push('peoplecounting');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
  width: 80%;
}
.logout {
  margin-top: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/faq.vue